/**
 * Modulo do component Boleto Detail (boletoDetail)
 */
(function(){
	angular.module('boletoDetailModule', []);
})();